// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3qgKB","container":"styles_container__3WSUf","qr":"styles_qr__Ivu4K","copy":"styles_copy__6tmhU","copyValue":"styles_copyValue__HzotC"};